import type { Color } from '@didaskill/types/web';

import { COLOR_GROUPS, HUE_GROUPS } from '../../config/colors/constants';
import { createContrastColors, createDarkHues } from '../../utils/colors';
import { type COLORS, HUES } from '../default/colors';

export const DARK_HUES = createDarkHues(HUES);

export const DARK_COLORS = {
  [COLOR_GROUPS.PRIMARY]: DARK_HUES[HUE_GROUPS.BLUE],
  [COLOR_GROUPS.SECONDARY]: DARK_HUES[HUE_GROUPS.ORANGE],
  [COLOR_GROUPS.TERTIARY]: DARK_HUES[HUE_GROUPS.PURPLE],
  [COLOR_GROUPS.SUCCESS]: DARK_HUES[HUE_GROUPS.GREEN],
  [COLOR_GROUPS.WARNING]: DARK_HUES[HUE_GROUPS.YELLOW],
  [COLOR_GROUPS.DANGER]: DARK_HUES[HUE_GROUPS.RED],
  [COLOR_GROUPS.GRAY]: DARK_HUES[HUE_GROUPS.GRAY],
} as Record<string, Color>;

export const DARK_CONTRAST_COLORS = createContrastColors(
  DARK_HUES,
  DARK_COLORS as typeof COLORS,
) as Record<string, Color>;
